<template>
  <div class="search-container">
    <div class="search-left">
      <!-- 搜索部分 -->
      <el-select size="small" v-model="searchParams.agreementName" placeholder="请选择协议名称" style="margin-right: 20px;"
        clearable>
        <el-option v-for="(item, index) in protocolList.value" :key="index" :label="item.name"
          :value="item.name"></el-option>
      </el-select>
    </div>
    <div class="search-right">
      <el-button v-auth="'PROTOCOL_COMPLIANCE_PROTOCOL_UPDATE_SEARCH'" type="primary" size="small"
        @click="search">查询</el-button>
      <el-button v-auth="'PROTOCOL_COMPLIANCE_PROTOCOL_UPDATE_ADD'" size="small" @click="add">新增</el-button>
    </div>
    <Add ref="addDialog" />
  </div>
</template>

<script>
import Add from './add.vue'
import Message from '@/components/Message'
export default {
  name: 'WebSaaSSearch',
  components: {
    Add
  },
  inject: ['searchParams', 'protocolList', 'loadList', 'receivePlatform', 'sendPlatform'],
  data() {
    return {

    };
  },


  methods: {
    search() {
      console.log("🚀 ~ receivePlatform:", this.receivePlatform)
      this.searchParams.current = 1;
      Message.success('搜索成功');
      this.loadList();
    },
    add() {
      this.$refs.addDialog.show()
    },
  },
};

</script>

<style lang="scss" scoped>
.search-container {
  display: flex;
  margin-bottom: 20px;

  .search-right {
    flex: 1;
    display: flex;
    justify-content: flex-end;
  }
}
</style>
